import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { SITE_REALTIME_REPORT_ID } from './siteRealtimeReportId';

export const siteReportFooterColumnDefinition = [
    FIELDS.SITE_NAME,
    FIELDS.SITE_ID,
    FIELDS.PUBLISHER_BLOCKING,
    FIELDS.PUBLISHER_BLOCKING_LEVEL,
    FIELDS.BID_MODIFICATION,
    FIELDS.BID_STRATEGY_PER_AFFILIATE,
].map(createFooterMapper(SITE_REALTIME_REPORT_ID));
